/* eslint react/no-multi-comp: 0 */

import React from 'react';
import { Section, preloader } from 'spectacle-ppa';

import balloonSlide from '../../baseSlides/balloonSlide';
import videoSlide from '../../baseSlides/videoSlide';

import apprenticeHandsHips3 from '../../images/characters/apprenticeHandsHips3.png';
import apprenticeHandsHips from '../../images/characters/apprenticeHandsHips.png';
import apprenticePointingUp2 from '../../images/characters/apprenticePointingUp2.png';
import apprenticesRowArmsFolded from '../../images/characters/apprenticesRowArmsFolded.png';
import apprenticeHandsHips2 from '../../images/characters/apprenticeHandsHips2.png';
import apprenticePointingUp from '../../images/characters/apprenticePointingUp.png';
import apprenticesPairHandsHips from '../../images/characters/apprenticesPairHandsHips.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './level1_superheroCalmingBreath.md';

const md = new MarkdownScript(markdownFile);

export function preloadClassActivity () {
  preloader([
    apprenticeHandsHips3,
    apprenticeHandsHips,
    apprenticePointingUp2,
    apprenticesRowArmsFolded,
    apprenticeHandsHips2,
    apprenticePointingUp,
    apprenticesPairHandsHips
  ]);
}

function superheroCalmingBreathSection (regionData) { // Superhero Calming Breath
  return (

    <Section id={'superhero-calming-breath'}>

      {/* Part 1 Intro */}
      {balloonSlide({
        id: 'part-1-intro',
        characterSide: 'right',
        characterImage: apprenticesPairHandsHips,
        notes: md.getSubSectionAsHtml('Part 1 Intro', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Part 1 Intro', 'Content', false, regionData)
      })}

      {/* Climate Change Emergencies */}
      {balloonSlide({
        id: 'climate-change-emergencies',
        characterSide: 'right',
        characterImage: apprenticePointingUp2,
        notes: md.getSubSectionAsHtml('Climate Change Emergencies', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Climate Change Emergencies', 'Content', false, regionData)
      })}

      {/* Keep Cool Song */}
      {videoSlide({
        id: 'song',
        notes: md.getSubSectionAsHtml('Keep Cool Song', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Keep Cool Song', 'YouTube', regionData),
        lowRes: md.getSectionMetadata('Keep Cool Song', 'LowRes', regionData)
      })}

      {/* Superhero Calming Breath */}
      {balloonSlide({
        id: 'superhero-calming-breath-intro',
        characterSide: 'left',
        characterImage: apprenticeHandsHips3,
        notes: md.getSubSectionAsHtml('Superhero Calming Breath', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Superhero Calming Breath', 'Content', false, regionData)
      })}

      {/* Superhero Calming Breath Instructions */}
      {balloonSlide({
        id: 'superhero-calming-breath-instructions',
        characterSide: 'right',
        characterImage: apprenticePointingUp,
        notes: md.getSubSectionAsHtml('Superhero Calming Breath Instructions', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Superhero Calming Breath Instructions', 'Content', false, regionData)
      })}

      {/* Surprise Test */}
      {balloonSlide({
        id: 'surprise-test',
        characterSide: 'right',
        characterImage: apprenticeHandsHips2,
        notes: md.getSubSectionAsHtml('Surprise Test', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Surprise Test', 'Content', false, regionData)
      })}

      {/* Drop Cover Hold On */}
      {balloonSlide({
        id: 'drop-cover-hold-on',
        characterSide: 'left',
        characterImage: apprenticesRowArmsFolded,
        notes: md.getSubSectionAsHtml('Drop Cover Hold On', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Drop Cover Hold On', 'Content', false, regionData)
      })}

    </Section>
  );
}

export default superheroCalmingBreathSection;



// WEBPACK FOOTER //
// ./programs/epsHybridAssembly/sections/06_superheroCalmingBreath/superheroCalmingBreathSection.jsx